/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PricesQueryVariables = Types.Exact<{
  products: Array<Types.ProductKey> | Types.ProductKey;
  type?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PricesQuery = { prices: Array<{ productId: string, prices: Array<{ markup?: number | null, currency?: string | null, validityPeriod?: { startDate?: any | null, endDate?: any | null } | null, rrp?: { min?: number | null, max?: number | null, currency?: string | null } | null, wspd?: { min?: number | null, max?: number | null, currency?: string | null } | null, wsp?: { min?: number | null, max?: number | null, currency?: string | null } | null, discount?: { min?: number | null, max?: number | null, currency?: string | null } | null }> } | null> };

export const PricesDocument = gql`
    query Prices($products: [ProductKey!]!, $type: String) {
  prices(products: $products, type: $type) {
    productId
    prices {
      validityPeriod {
        startDate
        endDate
      }
      rrp {
        min
        max
        currency
      }
      wspd {
        min
        max
        currency
      }
      markup
      wsp {
        min
        max
        currency
      }
      discount {
        min
        max
        currency
      }
      currency
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PricesGQL extends Apollo.Query<PricesQuery, PricesQueryVariables> {
    document = PricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }